export default __webpack_public_path__ + "static/media/Resources.b8b0029b.svg";